import { getHttpClient } from "./httpClient";
import { checkInBaseUrl } from "./checkIn.api";

export const getDocumentsForCheckIn = (checkInId: number) => getHttpClient().get(`${checkInBaseUrl}/${checkInId}/documents`);
